import React from 'react';
import styles from './CalendarTable.module.scss';
import Text from '../../atoms/text/Text';
import { useTranslation } from 'react-i18next';
import useIsRtl from '../../../app/helpers/isRtl';
import getCookie from '../../../app/helpers/getCookie';
const formatDate = (dateString, isRtl) => {
  const d = new Date(dateString);

  if (isRtl) {
    const day = d.getDate().toLocaleString('ar');
    const year = d.getFullYear().toString().toLocaleString('ar');
    const monthName = d.toLocaleString('ar', { month: 'long' });
    return `\u2067${day} ${monthName} ${year}\u2069`;
  }

  const monthName = d.toLocaleString('en', { month: 'long' });
  return `${d.getDate()} ${monthName} ${d.getFullYear()}`;
};
const transformEventData = (data, isRtl) => {
  const transformedEvents = {};

  data.forEach((month) => {
    month.calendarDays.forEach((event) => {
      const dateObj = new Date(event.fromDate);
      const year = dateObj.getFullYear();
      const formattedDate = formatDate(event.fromDate, isRtl);

      if (!transformedEvents[year]) {
        transformedEvents[year] = [];
      }

      transformedEvents[year].push({
        date: formattedDate,
        description: event.calendarText,
      });
    });
  });

  return transformedEvents;
};

const CalendarTable = ({ data, isHomePage }) => {
  const isEnglish = getCookie('googtrans')?.includes('/ar/en');

  const { t } = useTranslation();
  const isRtl = useIsRtl();
  const transformedData = transformEventData(data, isRtl);

  return (
    <div className={styles.calendarTableContainer}>
      {Object.keys(transformedData).map((year) => {
        const events = transformedData[year];
        const totalCount = events.length;

        return (
          <div key={year} className={styles.calendarTable}>
            <div
              className={`${styles.yearTitle} ${isHomePage ? styles['homepage-year'] : ''}`}
              style={{ flexDirection: !isRtl ? 'row-reverse' : '' }}
            >
              <Text
                title={
                  isRtl
                    ? `${t('common.year')} ${year}`
                    : `${year} ${t('common.year')}`
                }
                variant="text-bold-italic-20"
              />
              <Text
                title={`${totalCount} ${t('common.event')}${!isRtl && totalCount > 1 ? 's' : ''}`}
                variant="text-bold-italic-20"
              />
            </div>
            <div
              className={`${styles.table} ${isHomePage ? styles['homepage-table'] : ''}`}
            >
              {events.map((event, index) =>
                isRtl ? (
                  <div
                    key={index}
                    className={`${styles.eventRow} ${isHomePage ? styles['homepage-row'] : ''}`}
                    style={{ flexDirection: 'row-reverse' }}
                  >
                    <div className={styles.eventDescription}>
                      <Text
                        title={event.description}
                        variant="text-bold-italic-16-black"
                        className={styles['text']}
                      />
                    </div>{' '}
                    <div className={styles.eventDate}>
                      <Text
                        title={event.date}
                        variant="text-bold-italic-16-black"
                        className={styles['text']}
                        style={{ direction: isRtl ? 'rtl' : 'ltr' }}
                      />
                    </div>
                  </div>
                ) : (
                  <div
                    key={index}
                    className={`${styles.eventRow} ${isHomePage ? styles['homepage-row'] : ''}`}
                  >
                    <div
                      className={styles.eventDescription}
                      style={{ textAlign: 'left' }}
                    >
                      <Text
                        title={event.description}
                        variant="text-bold-italic-16-black"
                        className={styles['text']}
                      />
                    </div>{' '}
                    <div
                      className={styles.eventDate}
                      style={{ textAlign: 'right' }}
                    >
                      <Text
                        title={event.date}
                        variant="text-bold-italic-16-black"
                        className={`${styles['text']} ${isEnglish ? 'notranslate' : ''}`}
                        style={{ direction: isRtl ? 'rtl' : 'ltr' }}
                        isTranslated={false}
                      />
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CalendarTable;
